module.exports = __webpack_public_path__ + "static/media/img-excl-living-02dorms.bf63dc40.jpg";